var _g, _g2, _path, _g3, _g4, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointmentDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7176_39767)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7176_39767)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_7176_39767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 13.5625C15.5 11.4224 17.2349 9.6875 19.375 9.6875H50.375C52.515 9.6875 54.25 11.4224 54.25 13.5625V34.875C54.25 37.0151 52.515 38.75 50.375 38.75H19.375C17.2349 38.75 15.5 37.0151 15.5 34.875V13.5625Z",
    fill: "url(#paint0_linear_7176_39767)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 7.75,
    y: 17.4375,
    width: 38.75,
    height: 11.75
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(0px)",
      clipPath: "url(#bgblur_1_7176_39767_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_7176_39767)",
    "data-figma-bg-blur-radius": 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.75 19.375C7.75 18.305 8.61747 17.4375 9.6875 17.4375H44.5625C45.6325 17.4375 46.5 18.305 46.5 19.375V23.25C46.5 24.32 45.6325 25.1875 44.5625 25.1875H9.6875C8.61747 25.1875 7.75 24.32 7.75 23.25V19.375Z",
    fill: "white",
    fillOpacity: 0.4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2685 9.07426V0.846991H49.5582V9.07426H47.2685ZM44.2969 6.10835V3.81858H52.5241V6.10835H44.2969Z",
    fill: "#FFBB40"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 7.75,
    y: 27.125,
    width: 34.875,
    height: 9.8125
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(0px)",
      clipPath: "url(#bgblur_2_7176_39767_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_7176_39767)",
    "data-figma-bg-blur-radius": 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.75 28.0937C7.75 27.5587 8.18371 27.125 8.71875 27.125H41.6562C42.1913 27.125 42.625 27.5587 42.625 28.0937V31.9687C42.625 32.5038 42.1913 32.9375 41.6562 32.9375H8.71875C8.18371 32.9375 7.75 32.5038 7.75 31.9687V28.0937Z",
    fill: "white",
    fillOpacity: 0.4
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 7.75,
    y: 34.875,
    width: 19.375,
    height: 7.875
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(0px)",
      clipPath: "url(#bgblur_3_7176_39767_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ii_7176_39767)",
    "data-figma-bg-blur-radius": 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.75 35.8437C7.75 35.3087 8.18371 34.875 8.71875 34.875H26.1562C26.6913 34.875 27.125 35.3087 27.125 35.8437V37.7812C27.125 38.3163 26.6913 38.75 26.1562 38.75H8.71875C8.18371 38.75 7.75 38.3163 7.75 37.7812V35.8437Z",
    fill: "white",
    fillOpacity: 0.4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.785 48.8071C35.0585 52.5024 39.2084 52.4845 41.594 52.2001C46.3651 51.631 49.707 48.9471 48.7615 39.9186C48.4985 37.4107 46.5784 36.3701 44.3241 37.9087C43.4651 35.4719 39.3122 36.1789 39.553 38.4778L39.0276 33.462C38.8307 31.5811 37.795 29.8002 35.6518 30.0558C33.5085 30.3115 33.5289 32.8483 33.7771 35.2191L34.7108 44.1338L32.659 41.8394C31.997 41.2836 30.2625 39.713 28.8837 40.3853C27.5049 41.0576 27.2916 42.4797 28.0193 43.6624C28.747 44.8452 31.3295 46.4416 32.785 48.8071Z",
    fill: "url(#paint1_linear_7176_39767)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7176_39767",
    x: 1.75,
    y: -5.15283,
    width: 62.5,
    height: 67.4653,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.615686 0 0 0 0 0.407843 0 0 0 0 0.952941 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7176_39767"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7176_39767",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_7176_39767",
    x: 15.5,
    y: 9.6875,
    width: 38.75,
    height: 29.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7176_39767"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_7176_39767",
    x: 7.75,
    y: 17.4375,
    width: 38.75,
    height: 11.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7176_39767"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_7176_39767",
    result: "effect2_innerShadow_7176_39767"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_7176_39767_clip_path",
    transform: "translate(-7.75 -17.4375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.75 19.375C7.75 18.305 8.61747 17.4375 9.6875 17.4375H44.5625C45.6325 17.4375 46.5 18.305 46.5 19.375V23.25C46.5 24.32 45.6325 25.1875 44.5625 25.1875H9.6875C8.61747 25.1875 7.75 24.32 7.75 23.25V19.375Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_7176_39767",
    x: 7.75,
    y: 27.125,
    width: 34.875,
    height: 9.8125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7176_39767"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_7176_39767",
    result: "effect2_innerShadow_7176_39767"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_7176_39767_clip_path",
    transform: "translate(-7.75 -27.125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.75 28.0937C7.75 27.5587 8.18371 27.125 8.71875 27.125H41.6562C42.1913 27.125 42.625 27.5587 42.625 28.0937V31.9687C42.625 32.5038 42.1913 32.9375 41.6562 32.9375H8.71875C8.18371 32.9375 7.75 32.5038 7.75 31.9687V28.0937Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ii_7176_39767",
    x: 7.75,
    y: 34.875,
    width: 19.375,
    height: 7.875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7176_39767"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_7176_39767",
    result: "effect2_innerShadow_7176_39767"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_3_7176_39767_clip_path",
    transform: "translate(-7.75 -34.875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.75 35.8437C7.75 35.3087 8.18371 34.875 8.71875 34.875H26.1562C26.6913 34.875 27.125 35.3087 27.125 35.8437V37.7812C27.125 38.3163 26.6913 38.75 26.1562 38.75H8.71875C8.18371 38.75 7.75 38.3163 7.75 37.7812V35.8437Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7176_39767",
    x1: 34.875,
    y1: 9.6875,
    x2: 34.875,
    y2: 38.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6966FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D68F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7176_39767",
    x1: 45.3077,
    y1: 47.0962,
    x2: 33.3419,
    y2: 35.1635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0113208,
    stopColor: "#FFAC16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD9E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7176_39767"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentDetails);
export default __webpack_public_path__ + "static/media/AppointmentDetails.7907e981fd422404c5e448d1fa344a56.svg";
export { ForwardRef as ReactComponent };